<template>
  <div class="uploaddata">
    <!-- <el-button>DTR上传</el-button> -->
    <div class="content">
      <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" inlineMessage status-icon :model="formCase">
        <el-form-item label="经销店名称" prop="dealerName">
          <el-input disabled v-model="formCase.dealerName"></el-input>
        </el-form-item>
        <el-form-item label="服务委托书编号" prop="caseNo">
          <el-input readonly v-model="formCase.caseNo"></el-input>
        </el-form-item>
        <el-form-item label="VIN" prop="vin">
          <el-input readonly v-model="formCase.vin"></el-input>
        </el-form-item>
        <el-form-item label="上传人" prop="uploadUserName">
          <el-input readonly v-model="formCase.uploadUserName"></el-input>
        </el-form-item>
        <el-form-item label="上传时间" prop="uploadDatetime">
          <el-input readonly v-model="formCase.uploadDatetime"></el-input>
        </el-form-item>
        <div  v-if="formCase.attaGroup">
        <div class="" v-for="it in Object.keys(formCase.attaGroup)">
          <el-form-item label="" prop="title">
            <span style="margin-right: 20px; width: 100px;float: left;">{{it}}</span>
            <!-- <el-button type="primary" size="mini" @click="confirmUserFn(it)">全部承认</el-button> -->
          </el-form-item>
          <el-row class="row-bg">
            <el-col :span="10" style="margin-right: 6%;position:relative" v-for="(item, index) in formCase.attaGroup[it]" :key="index">
              <img :src="item.url" preview="2" style="width: 100%" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0">
              <!-- <video :src="item.url" preload="auto" x5-playsinline style="width: 150px;height:150px;posiiton:relative;z-index:99999;"  x-webkit-airplay="true" x5-video-player-type="h5" x5-video-player-fullscreen="true" v-if="item.type&&item.type.indexOf('video')>=0"  webkit-playsinline="true" playsinline="true" controls></video> -->
              <el-row style="height:180px; width:100%;" v-else-if="item.type&&item.type.indexOf('video')>=0">
                <div style="position:absolute;height:160px;width:100%;" >
                  <video :src="item.url" style="width: 100%;object-fit:fill;height: 100%;" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
                  <a style="position:relative;top:0;right:-100px;z-index:999;" :href="item.url" download>下载</a>
                </div>
              </el-row>
              <div style="width:100%;height:100%;" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i><a :href="'api/'+item.url" style="position:absolute;width:100%;height:100%;top:0;left:0" alt="" download></a></div>
              <el-button v-if="user.type===1&&user.dtrStatus==='2'" type="primary" size="mini" @click="delFn(item.id)">删除</el-button>
              <div v-if="item.dtrStatus==='被打回'">
                附件状态： 退回
              </div>
            </el-col>
          </el-row>
        </div>
        </div>
        <!-- <el-row class="row-bg" v-if="fileList.length>0">
          <el-col :span="24">
            附件 :
          </el-col>
          <el-col :span="10" style="margin-right: 6%;position:relative" v-for="(item, index) in fileList" :key="index">
            <div class="close" @click="handleRemove(item.id)">
                <i class="el-icon-close"></i>
            </div>
            <img style="width: 100%;" :src="item.url" preview="2" alt="" class="picture" v-if="item.type&&item.type.indexOf('image')>=0">
            <el-row style="height:180px; width:100%;" v-else-if="item.type&&item.type.indexOf('video')>=0">
              <div style="position:absolute;height:160px;width:100%;" >
                <video style="width: 100%;height: 100%;" :src="item.url" controls="controls" preload="auto" x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-playsinline></video>
                <a style="position:relative;top:0;right:-100px;z-index:999;" :href="item.url" download>下载</a>
              </div>
            </el-row>
            <div style="width:100%;height:100%;" v-else><i class="el-icon-document" style="color:#000;font-size:80px;text-align:center;line-height:148px;width:100%;float:left"></i><a :href="'api/'+item.url" style="position:absolute;width:100%;height:100%;top:0;left:0" alt="" download></a></div>
          </el-col>
        </el-row> -->
        <!-- <el-form-item label="附件"  v-if="users.dlrAdvanceUser">

          <Upload url="api/file/Upload" :caseNo="formCase.caseNo" :vin="formCase.vin" :attac="formCase.attachmentIds" :fileList="fileList" @sub1="subs" @changeAttach="changeAttachs"></Upload>
        </el-form-item> -->
        <el-form-item style="text-align: center">
          <el-button type="info" @click.native="cancels">取消</el-button><!--
          <el-button type="primary" @click.native="onSubmit">提交</el-button> -->
          <!-- <el-button type="success" @click.native="onSave">保存</el-button> -->
          <!-- <el-button type="danger" @click.native="onDelete">删除</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/javascript">
import Upload from './Upload'
import axios from '@/utils/api.request'
import { Toast, MessageBox } from 'mint-ui'
import {getImg} from '@/api/case'
import {getDetailData, removeOneCase} from '@/api/quality'
import Global from '@/config/global.js'
export default{
  components: { Upload },
  data() {
    return {
      rules: {},
      formCase: {},
      user: {},
      fileList: [],
      attachmentIdss: [],
      sub: false,
      ticketNum: '',
      vin: ''
    }
  },
  created() {
     this.user = JSON.parse(localStorage.getItem('user'))
    if(this.$route.params){
      this.ticketNum = this.$route.params.ticketNum
      this.vin = this.$route.params.vin
    }
    this.getData()
  },
  methods: {
    getData() {
      getDetailData({caseNo:this.ticketNum, vin:this.vin}).then(res => {
        if(res.data.success){
          this.formCase = res.data.data
          if(this.formCase.attaGroup&&Object.keys(this.formCase.attaGroup)){
            let groupList = Object.keys(this.formCase.attaGroup)
            groupList.forEach((it) => {
              let arr = []
              this.formCase.attaGroup[it].forEach((v, i) => {
                let json = {
                  id: v.id,
                  name: v.rawName,
                  url: v.url,
                  type: v.mime,
                  dtrStatus: v.dtrStatus
                }
                arr.push(json)
                if(v.mime.indexOf('image')>=0){
                  getImg(v.url).then(resp=>{
                    var mimeType = v.mime.toLowerCase();
                    var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                    arr[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                  })
                }else if(v.mime.indexOf('video')>=0){
                   arr[i].url = Global.server_api + v.url;
                }

              })
              this.formCase.attaGroup[it] = arr
            })

          }
          if(this.formCase.attaList){
            this.fileList = []
            this.formCase.attaList.forEach((v, i) => {

              let json = {
                id: v.id,
                name: v.rawName,
                url: v.url,
                type: v.mime,
                dtrStatus: v.dtrStatus
              }
              this.fileList.push(json)
              if(v.mime.indexOf('image')>=0){
                getImg(v.url).then(resp=>{
                  var mimeType = v.mime.toLowerCase();
                  var imgBase64 = new Buffer(resp.data, 'binary').toString('base64');
                  this.fileList[i].url = 'data:' + mimeType + ';base64,' + imgBase64;
                })
              }else if(v.mime.indexOf('video')>=0){
                 this.fileList[i].url = Global.server_api + v.url;
              }

            })
          }
          Toast({
            message: '获取案件成功',
            iconClass: 'icon el-icon-check'
          })
        }else{
          // this.$message({
          //   type: 'error',
          //   message: res.data.msg
          // })
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    onDelete() {
    },
    handleRemove(id) {
      removeOneCase({id : id,caseNo: this.formCase.caseNo, vin: this.formCase.vin}).then(res => {
        if(res.data.success){
          this.getData()
        }else{
          Toast({
              message: res.data.msg,
              position: 'top',
          })
        }

      })
    },
    delFn(id) {
      removeOneCase({caseNo: this.formCase.caseNo, vin: this.formCase.vin, id: id}).then(res => {
        if(res.data.success){
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getData()
        }else{
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    subs(data) {
      this.sub = data
    },
    changeAttachs(data) {
        console.log(data)
      this.attachmentIdss = data;
    },
    cancels() {
      this.$router.go(-1);
    },
    getSign() {
      let url = location.href.split('#')[0]
    },
  }
}
</script>

<style scoped>
.uploaddata{
  background: #fff;
  text-align: left;
  padding: 0.3rem;
  position: relative;
  top: -100px;
  z-index: 99;
}
.close {
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 30px;
        font-size: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        z-index: 99999;
    }
</style>
